// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_Dzu","cls2":"search_work_card_redesign-cls2_OZP search_work_card_redesign-cls1_Dzu"};